import { render, staticRenderFns } from "./SmsHistoryEmptyState.vue?vue&type=template&id=9a82f608&scoped=true"
var script = {}
import style0 from "./SmsHistoryEmptyState.vue?vue&type=style&index=0&id=9a82f608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a82f608",
  null
  
)

export default component.exports